// Controls what gets cached, for how long, and security level.
// SESSION_TTL matches the 8-hour work session in attendance system.

export const SESSION_TTL_MS = 24 * 60 * 60 * 1000; // 1 day

// Collections that are NEVER cached — always fresh from Firestore.
// These contain financial, security, or private data.
export const NEVER_CACHE = new Set([
  'salary_slips',
  'login_lockouts',
  'access_logs',
  'notifications',
  'notification_logs',
  'notifications_queue',
  'share_link_views',
  'app_errors',
]);

// Collections cached in MEMORY only (lost on page refresh — safest).
// Use for frequently-changing data where staleness matters.
export const MEMORY_ONLY = new Set([
  'portal_threads',         // chat messages — refresh on revisit
  'daily_updates',          // personal log — memory only
  'attendance',             // live session data
]);

// Collections cached in IndexedDB (survives refresh within TTL).
// Safe for relatively stable reference data.
export const PERSISTENT = new Set([
  'authorized_users',       // team member list
  'app_config',             // feature flags
  'mission_projects',       // project data
  'mission_milestones',
  'experiments',            // experiment list (not thread)
  'badge_definitions',
  'announcements',
  'tasks',
  'compliance_items',
  'obc_modules',
]);

// Portal post collections — memory cache only (content changes)
export const PORTAL_COLLECTIONS = new Set([
  'mission_planning_posts',
  'embedded_posts',
  'system_posts',
  'operations_posts',
  'c_suite_posts',
  'payload_posts',
  'prompt_engineering_posts',
  'experimental_results_posts',
]);

// Max items to keep per collection in cache
export const MAX_CACHE_SIZE = 200;

// Cache key prefix — all cache entries are namespaced
export const CACHE_PREFIX = 'smc_cache_';
